import { SS_CONTROL_TYPE } from '../constants/form-manager.constants';

export const getChildren = ({ controlId, formModel }) => {
  const children = formModel[controlId]?.childrenNodes;

  if (!children?.length) {
    return [];
  }
  const firstChild = formModel[children[0]];

  if (firstChild?.controlType === SS_CONTROL_TYPE.FORM) {
    return getChildren({ controlId: firstChild?.controlId, formModel });
  }

  return children;
};

export const getPositionsForControls = ({
  controlId,
  formModel,
  controlsPositions = {},
  indexDetail,
}) => {
  const children = getChildren({ controlId, formModel });
  const controlType = formModel[controlId]?.controlType;

  if (controlType !== SS_CONTROL_TYPE.ADVANCED_TEXT_BOX && controlId !== 'formBox') {
    controlsPositions[controlId] = indexDetail.index;
    indexDetail.index++;
  }

  children.forEach((controlId) => {
    if (
      formModel[controlId].controlType === SS_CONTROL_TYPE.GRID ||
      formModel[controlId].controlType === SS_CONTROL_TYPE.TAB_SET
    ) {
      controlsPositions[controlId] = indexDetail.index;
      indexDetail.index++;

      getPositionForGridOrTabSetControls({ controlId, formModel, controlsPositions, indexDetail });
    } else {
      getPositionsForControls({ controlId, formModel, controlsPositions, indexDetail });
    }
  });
};

export const getPositionForGridOrTabSetControls = ({
  controlId,
  formModel,
  controlsPositions,
  indexDetail,
}) => {
  const { childrenNodes = [] } = formModel[controlId];
  const gridControls = [];

  const gridColumns = childrenNodes.filter((gridChildId) => {
    return (
      formModel[gridChildId]?.controlType === SS_CONTROL_TYPE.GRID_COLUMN ||
      formModel[gridChildId]?.controlType === SS_CONTROL_TYPE.SINGLE_TAB
    );
  });

  gridColumns.forEach((columnId) => {
    const columnControls = formModel[columnId]?.childrenNodes ?? [];
    gridControls.push(...columnControls);

    controlsPositions[columnId] = indexDetail.index;
    indexDetail.index++;
  });

  gridControls.forEach((gridControlId) =>
    getPositionsForControls({ controlId: gridControlId, formModel, controlsPositions, indexDetail })
  );

  const subGrids = childrenNodes.filter((gridChildId) => {
    return formModel[gridChildId]?.controlType === SS_CONTROL_TYPE.SUB_GRID;
  });

  subGrids.forEach((subGridId) =>
    getPositionsForControls({ controlId: subGridId, formModel, controlsPositions, indexDetail })
  );
};

export const getPositions = (formModel) => {
  const controlsPositions = {};
  const indexDetail = { index: 0 };

  getPositionsForControls({ controlId: 'formBox', formModel, controlsPositions, indexDetail });

  return controlsPositions;
};

/**
 * find index of ssGridColumn in the ssGrid and make current control position based on ssGrid as a container
 */
export const generatePositionForGridControl = (formModel, control, parent) => {
  const parentControlNode = formModel[parent];
  const parentControlPosition =
    formModel[parentControlNode?.parent]?.childrenNodes?.findIndex((el) => el === parent) || 0;

  return parentControlPosition + (control.position + 1);
};
